import Select2 from '../../../src/js/shared/select2';

'use strict';

const $ = jQuery.noConflict();
$(function() {

	const contact = {

		init: function() {
			this.cacheDOM();
			this.bindEvents();
			this.initContactMethodValue();
			this.initSelect();
		},

		cacheDOM: function() {
			this.$section = $('.contact');
			this.$radioInputs = $('.contact [name="contact-followup"]');
			this.$hiddenContactMethod = $('#contact-followup-value');
			this.$select = $('.contact .js-contact-select');
			this.$thankyou = $('.contact .js-contact-thankyou');
			this.$submitBtn = $('.contact .js-contact-submit');
		},

		bindEvents: function() {
			const _this = this;
			_this.$radioInputs.on('change', function() {
				_this.$hiddenContactMethod.val($(this).val());
			});
			$(document).on('click', '.contact .js-contact-submit', function() {
				const $form = $(this).closest('form');
				$form.find('.js-contact-loader').addClass('is-loading');
				_this.$submitBtn.prop('disabled', true);
				$form.find('.cf7-submit-hidden').trigger('click');
			});
			$(document).on('wpcf7invalid wpcf7mailfailed wpcf7spam', function() {
				_this.$section.find('.js-contact-loader').removeClass('is-loading');
				_this.$submitBtn.prop('disabled', false);
			});
			$(document).on('wpcf7mailsent', function() {
				_this.$section.find('.js-contact-loader').removeClass('is-loading');
				_this.$submitBtn.prop('disabled', false);
				_this.$section.addClass('form-is-sent');
				_this.$thankyou.attr('aria-hidden', 'false');
			});
			$(window).on('resize', function() {
				_this.$select.each(function() {
					$(this).trigger('select2-resize');
				});
			});
		},

		initContactMethodValue: function() {
			const $checked = this.$radioInputs.filter(':checked');
			if ($checked.length) {
				this.$hiddenContactMethod.val($checked.val());
			}
		},

		initSelect: function() {
			this.$select.each(function() {
				Select2.initializeSelect2(this, {
					width: '100%',
					dropdownParent: $(this).parent(),
					placeholder: 'Select an inquiry type',
					templateResult: function(data) {
						if (!data.id) return null;
						return data.text;
					}
				});
			});
		},

	};

	if ($('.contact').length) {
		contact.init();
	}
});
